import { useMemo } from "react";
import defaults, { useProviderArgsDefaults } from "./useProviderArgsDefaults.js";
import { isObject } from "lodash";
export default function useProviderArgs(providerOrParamsOrGlobalOptions, globalOptionsOrDeps, deps) {
  const provider = useMemo(() => {
    if (typeof providerOrParamsOrGlobalOptions === "string") {
      return providerOrParamsOrGlobalOptions;
    }
    return useProviderArgsDefaults.provider;
  }, [providerOrParamsOrGlobalOptions, globalOptionsOrDeps]);
  const options = useMemo(() => {
    let localOptions = {};
    if (isObject(providerOrParamsOrGlobalOptions)) {
      localOptions = providerOrParamsOrGlobalOptions;
    } else if (isObject(globalOptionsOrDeps)) {
      localOptions = globalOptionsOrDeps;
    }
    return {
      ...defaults,
      ...localOptions
    };
  }, [providerOrParamsOrGlobalOptions, globalOptionsOrDeps]);
  const requestInit = useMemo(() => {
    const customOptionKeys = [...Object.keys(useProviderArgsDefaults), ...Object.keys(useProviderArgsDefaults.customOptions)];
    const {
      args = null,
      ...restOptions
    } = Object.keys(options).reduce((acc, key) => {
      if (!customOptionKeys.includes(key)) acc[key] = options[key];
      return acc;
    }, {});
    return {
      options: {
        ...restOptions
      },
      args
    };
  }, [options]);
  const dependencies = useMemo(() => {
    if (Array.isArray(globalOptionsOrDeps)) return globalOptionsOrDeps;
    if (Array.isArray(deps)) return deps;
    return defaults.dependencies;
  }, [globalOptionsOrDeps, deps]);
  const loading = options.loading || Array.isArray(dependencies);
  const customOptions = useMemo(() => {
    const customOptionKeys = Object.keys(useProviderArgsDefaults.customOptions);
    const customOptions = customOptionKeys.reduce((opts, key) => {
      opts[key] = options[key];
      return opts;
    }, {});
    return {
      ...customOptions,
      loading
    };
  }, [options]);
  return {
    provider,
    customOptions,
    requestInit,
    dependencies
  };
}
//# sourceMappingURL=useProviderArgs.js.map